import { Link } from "react-router-dom";

import { ROUTES } from "@/shared/model/routes";
import Logo from "@/shared/ui/logo";

export function NavLogo() {
  return (
    <Link to={ROUTES.HOME} className="flex items-center gap-2">
      <Logo />
    </Link>
  );
}
